/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2019 Bulb Inc.  For more information, please email contact@hellobulb.com.
*/
angular.module('bulbApp.ageVerificationModule')
  .component('bulbAgeVerification', {
    templateUrl: 'ajs/components/ageverification/age-verification-modal.html',
    controllerAs: 'ageVerificationCtrl',
    controller: ['$translate', '$window', 'moment', 'BulbAuthService', 'BulbBusyService',
      'BulbModalService', 'Restangular', 'CONFIG', AgeVerificationController],
  });

// Controller to handle the age verification logic
function AgeVerificationController(
  $translate,
  $window,
  moment,
  BulbAuthService,
  BulbBusyService,
  BulbModalService,
  Restangular,
  CONFIG,
) {
  const that = this;
  const MINIMUM_AGE_YEARS = CONFIG.minimumAgeYears;

  // Needed translation for the HTML template:
  this.loginExists = $translate.instant('age_verification_modal_login_exists');
  this.currentUser = BulbAuthService.currentUser;

  this.dateOptions = {
    dateFormat: 'm/d/Y',
    maxDate: 'today',
  };

  // Submit function for the form:
  this.submit = function () {
    BulbAuthService.fetchCurrentUser().then(() => {
      BulbBusyService.showBusyDuring(
        Restangular.one('accounts', that.currentUser.id).post(
          'ageverify',
          { dateOfBirth: that.inputDateInMillis },
        ).then((isUnderAge) => {
          if (isUnderAge) {
            const coppaModalOptions = {
              fontAwesomeCode: 'fas fa-exclamation-triangle',
              templateUrl: 'signin.coppa.nested',
              windowClass: 'updated-modal-design bulb-coppa-modal',
              titleCode: 'coppa_underaged_user_modal_title',
              backdrop: 'static',
              keyboard: false,
              showCancelButton: false,
              showOkButton: false,
              closeOnClick: false,
            };

            BulbModalService.open(coppaModalOptions);
            return false;
          }
          $window.location.href = `/${that.currentUser.username}`;
        }),
      );
    });
  };

  /**
   * Pops up the modal for parental consent form.
   */
  this.showCOPPADateValidationModal = function () {
    return BulbModalService.show({
      titleCode: 'coppa_date_validation_alert_title',
      bodyCode: 'coppa_date_validation_alert_body',
      showCancelButton: false,
      showOkButton: false,
      closeOnClick: true,
    });
  };

  /**
   * Checks the given date for being under age.
   * @param date
   */
  this.underAgedUserCheck = function (date) {
    const dateNow = moment();
    const todayMinusThirteenYears = dateNow.subtract(MINIMUM_AGE_YEARS, 'years').valueOf();
    if (+date >= +todayMinusThirteenYears) {
      that.showCOPPADateValidationModal();
    }
    that.inputDateInMillis = date;
  };

  /**
   * Validates the date on the form.
   */
  this.validateDateOfBirth = function (ageVerificationForm) {
    let dateToValidate;
    const validDateFormats = ['MM/DD/YYYY', 'MM-DD-YYYY', 'MMDDYYYY', 'YYYY-MM-DD'];

    if (that.dateOfBirth.length >= 6 && that.dateOfBirth.length <= 10) {
      dateToValidate = moment(that.dateOfBirth, validDateFormats, true);
    } else {
      ageVerificationForm.dateOfBirth.$setValidity('dateOfBirth', false);
      that.showCOPPADateValidationModal();
      return;
    }
    // take an date input of valid length and check to see if it's actually valid. i.e. 02/30 should be false.
    if (dateToValidate && dateToValidate.isValid()) {
      ageVerificationForm.dateOfBirth.$setValidity('dateOfBirth', true);
      that.inputDateInMillis = dateToValidate.valueOf();
    } else {
      ageVerificationForm.dateOfBirth.$setValidity('dateOfBirth', false);
    }
  };
}
